import Deals from './Deals.js';

export default Deals;